import styled from '@emotion/styled';

const Container = styled('section')`
  border-bottom: 1px solid ${({ theme }) => theme.colors.dark['05']};
  padding-bottom: 2rem;
`;

export { Container };
